import { $ } from "js/vendor";
import log from "js/core/logger";
import { getStaticUrl } from "js/config";
import { SlideCanvas } from "js/core/canvas";

const FallbackCanvas = SlideCanvas.extend({
    initialize: function(options) {
        this.options = options;

        this.imageUrl = options.imageUrl;
        this.playbackIndex = options.index;
        this.dataModel = options.model;

        this.$el.attr("id", this.model.id + this.playbackIndex);

        this.CANVAS_WIDTH = this.options.canvasWidth || 1024;
        this.CANVAS_HEIGHT = this.options.canvasHeight || 768;
        this.$el
            .css("width", this.CANVAS_WIDTH)
            .css("height", this.CANVAS_HEIGHT);

        this.isPlayback = options.isPlayback;
        this.isEditable = false;
    },

    render: function() {
        this.$el.empty();
        this.$el.attr("id", this.model.id + this.playbackIndex);
        this.$el.css({
            width: this.CANVAS_WIDTH,
            height: this.CANVAS_HEIGHT
        });

        const $img = this.$el.addEl($.img(null));
        $img.opacity(0);
        this.$el.spinner(true);
        this.renderSlidePromise = new Promise((resolve, reject) => {
            $img.one("load", () => {
                this.isRendered = true;
                this.isReady = true;
                this.$el.spinner(false);
                $img.velocity("transition.fadeIn");
                resolve(this);
            });
            $img.one("error", () => {
                log.info(log.FALLBACK_CANVAS)(`Image Not Found for ${this.model.id}`);
                $img.attr("src", getStaticUrl("/images/slide-error.png"));
                this.isRendered = true;
                this.isReady = true;
                this.$el.spinner(false);
                $img.velocity("transition.fadeIn");
                resolve(this);
            });
            let url = this.imageUrl;
            $img.attr("src", url);
            $img.width(1280);
        });

        return this;
    },

    renderSlide: function() {
        if (!this.renderSlidePromise) {
            this.render();
        }
        return this.renderSlidePromise;
    },

    getAnimationManager: function(options) {
        return null;
    }
});

export { FallbackCanvas };
